import React from 'react'

export default function RosterLegendWidget({ legendItems, getLegendItemLabel, title }) {
  return (
    <div className="d-flex flex-column gap-2 w-100">
      {title && <h6>{title}</h6>}
      <div className="d-flex flex-column gap-1">
        {legendItems?.map((itm, idx) => {
          const title = getLegendItemLabel(itm)
          return (
            <div className="d-flex align-items-center gap-2" key={idx}>
              <div
                style={{
                  borderRadius: '80px',
                  backgroundColor: itm?.bgColor,
                  border: '1px grey #000',
                  width: '12px',
                  height: '12px'
                }}
              ></div>
              <div>{title || ''}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
